import React from 'react'
import MDB4Switch from './../../forms/MDB4Switch'

const CustomSwitch = ({
  checked,
  onChange,
  disabled,
  name,
  className = '',
  labelLeft,
  labelRight,
  labelOff,
  labelOn,
}) => {
  const handleChange = () => {
    if (disabled) return
    const value = !checked
    if (typeof onChange === 'function') {
      onChange(name != null ? { target: { name, value } } : value)
    }
  }

  const left = labelLeft != null ? labelLeft : labelOff
  const right = labelRight != null ? labelRight : labelOn

  return (
    <MDB4Switch
      className={className}
      {...(left != null ? { labelLeft: left } : {})}
      {...(right != null ? { labelRight: right } : {})}
      name={name}
      disabled={disabled}
      checked={!!checked}
      onChange={handleChange}
    />
  )
}

export default CustomSwitch
